"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCardiology = createCardiology;
const dse_1 = require("../../../forms/ktx/transplantation-screening/cardiology/dse");
const messages_1 = require("./messages");
const events_1 = require("../../../events");
const queries_1 = require("../queries");
const shared_1 = require("../../shared");
const createBloodPressure_1 = require("./createBloodPressure");
const messages = {
    cardiology: {
        id: "ktx.dashboard.cardiology",
        defaultMessage: "Kardiológia"
    }
};
const groups = [
    {
        label: messages_1.messages.abnormal,
        variant: "dark",
        predicate: (event) => event !== undefined && event.value.result === dse_1.Result.ABNORMAL
    },
    {
        label: messages_1.messages.normal,
        variant: "light",
        predicate: (event) => event !== undefined && event.value.result === dse_1.Result.NORMAL
    }
];
const values = Object.values(queries_1.cardiologyQueries).map(query => ({
    query,
    label: shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(query.interpretation)]
}));
function createCardiology(intl, { events }) {
    const bloodPressure = (0, createBloodPressure_1.createBloodPressure)(intl, { events });
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([bloodPressure, list]);
    return (0, shared_1.createSection)(intl, { label: messages.cardiology, content });
}
